      

$(".review-close").click(function() {
$('.review-popup').hide();
$(this).hide();
$('.f-overlay').hide();
});
$(".f-overlay").click(function() {
$('.review-popup').hide();
$('.review-close').hide();
$('.f-overlay').hide();
});
$(" .review-open").click(function() {
$('.review-popup').show();
$('.review-close').show();
$('.f-overlay').show();
});

$(".nfs-announcement-bar").click(function() {
$('html, body').animate({
scrollTop: $("#subscribe-now").offset().top
}, 1000);
});

$(".clncl-btn").click(function() {
$('html, body').animate({
scrollTop: $("#subscribe-now").offset().top
}, 1000);
});

$(window).scroll(function() {
var btn = $('.stt');
if ($(window).scrollTop() > 300) {
btn.addClass('show');
} else {
btn.removeClass('show');
}
});


setInterval(function() {
var totalwd = window.innerWidth;
var cntwd = $('.nfs-slideshow-box .page-width').innerWidth();
var remain = ((totalwd - cntwd) / 2) + 30;
$('.nfs-slideshow-box .page-width .img-lg img').css('transform', 'translateX(' + remain + 'px)');
/* console.log(totalwd);
console.log(cntwd);
console.log(remain);*/
}, 300);

$(window).scroll(function(){
var sticky = $('.nfs-header'),
scroll = $(window).scrollTop();

if (scroll >= 50) sticky.addClass('stick-nheader');
else sticky.removeClass('stick-nheader');
});

    window.onload = function(){
  document.getElementById("ozload").style.display='none';
};



$(" .okeReviews").click(function() {
$('.review-popup').show();
$('.review-close').show();
$('.f-overlay').show();
});



      $(" .tm-pt1>a:first-child").click(function() {
      $('.tm-ingpopup').show();
        $('.tm-overlay').show();
      });
    $(" .tm-pt1>a:nth-child(2)").click(function() {
      $('.tm-iingpopup').show();
      $('.tm-overlay').show();
      });
    $(" .tm-ingpopup>span").click(function() {
      $('.tm-ingpopup').hide();
      $('.tm-overlay').hide();
      });
     $(" .tm-overlay").click(function() {
      $('.tm-ingpopup').hide();
      $('.tm-iingpopup').hide();
       $('.tm-overlay').hide();
      });
    
    $(".tm-iingpopup>span").click(function() {
      $('.tm-iingpopup').hide();
      $('.tm-overlay').hide();
      });
    
 
      $(".tmn-variant>div:first-child").click();
      $('#AddToCartForm-8458422124785 #ProductSelect-8458422124785-option-0>div:first-child label').click();
 $('.tmbuyboxa #AddToCartForm-tmoz3 #ProductSelect-tmoz3-option-0>div:first-child label').click();
     
      $('#tmsformd-8458422124785 fieldset>div:first-child label').trigger('click');
      $('.tmbprice').text('$336.00');
      $('.tmperbottle').text('$2.00');
   
      $(".tmbuyboxa .tmn-variant>div:first-child").click(function() {
      $('.tmbuyboxa .tmn-variant>div.tmactive').removeClass('tmactive');
      $(this).addClass('tmactive');
      $('.tmbuyboxa .tmtwoshot').show();
      $('.tmbuyboxa .tmoneshot').hide();
      $('.tmbuyboxa  #AddToCart-8458422124785').show();
      $('.tmbuyboxa  #AddToCart-tmoz2').hide();
      $('.tmbuyboxa #AddToCart-tmoz3').show();
      $('.tmbuyboxa  #AddToCart-tmoz4').hide();
      $('.tmbuyboxa .tmbprice').text('$336.00');
      $('.tmbuyboxa .tmtwoshot>div.tmmactive').removeClass('tmmactive');
      $('.tmbuyboxa .tmssa').addClass('tmmactive');
        $('.tmbuyboxa #AddToCartForm-8458422124785 #ProductSelect-8458422124785-option-0>div:first-child label').trigger('click');
     
        $('.tmbuyboxa #AddToCartForm-8458422124785 #ProductSelect-8458422124785-option-0>div:first-child label').trigger('click');
      $('.tmbuyboxa .tmperbottle').text('$2.00');
      $('.tmbuyboxa .tmnservinga').text('144 Servings (18 bottles)');
      });

      $(".tmbuyboxa .tmn-variant>div:nth-child(2)").click(function() {
      $('.tmbuyboxa .tmn-variant>div.tmactive').removeClass('tmactive');
      $(this).addClass('tmactive');
      $('.tmbuyboxa .tmtwoshot').hide();
      $('.tmbuyboxa .tmoneshot').show();
      $('.tmbuyboxa #AddToCart-8458422124785').hide();
      $('.tmbuyboxa #AddToCart-tmoz3').hide();
      $('.tmbuyboxa #AddToCart-tmoz4').show();
      $('.tmbuyboxa #AddToCart-tmoz2').show();
      $('.tmbuyboxa .tmbpricee').text('$168.00');
      $('.tmbuyboxa #ProductSection-tmoz2 fieldset>div:first-child label').trigger('click');
      $('.tmbuyboxa #ProductSection-tmoz2 fieldset>div:first-child label').trigger('click');
    
        $('.tmbuyboxa .tmoneshot>div.tmmactive').removeClass('tmmactive');
      $('.tmbuyboxa .tmssc').addClass('tmmactive');
      $('.tmbuyboxa .tmperbottlee').text('$2.00');
      $('.tmbuyboxa .tmnservingb').text('72 Servings (9 bottles)');
      });
    
      $(".tmbuyboxa .tmssa").click(function() {
      $('.tmbuyboxa .tmtwoshot>div.tmmactive').removeClass('tmmactive');
      $(this).addClass('tmmactive');
      $('.tmbuyboxa #AddToCartForm-8458422124785 #ProductSelect-8458422124785-option-0>div:first-child label').trigger('click');
         $('.tmbuyboxa #AddToCartForm-8458422124785 #ProductSelect-8458422124785-option-0>div:first-child label').trigger('click');
 
        $('.tmbuyboxa .tmbprice').text('$336.00');
      $('.tmbuyboxa .tmperbottle').text('$2.00');
      $('.tmbuyboxa .tmnservinga').text('144 Servings (18 bottles)');
      });
    
      $(".tmbuyboxa .tmssb").click(function() {
      $('.tmbuyboxa .tmtwoshot>div.tmmactive').removeClass('tmmactive');
      $(this).addClass('tmmactive');
        $('.tmbuyboxa #AddToCartForm-8458422124785 #ProductSelect-8458422124785-option-0>div:nth-child(2) label').trigger('click');
        $('.tmbuyboxa #AddToCartForm-8458422124785 #ProductSelect-8458422124785-option-0>div:nth-child(2) label').trigger('click');
    
        $('.tmbuyboxa .tmbprice').text('$136.00');
      $('.tmbuyboxa .tmperbottle').text('$2.83');
      $('.tmbuyboxa .tmnservinga').text('48 Servings (6 bottles)');
      });
    
      $(".tmbuyboxa .tmssc").click(function() {
      $('.tmbuyboxa .tmoneshot>div.tmmactive').removeClass('tmmactive');
      $(this).addClass('tmmactive');
      $('.tmbuyboxa #ProductSection-tmoz2 fieldset>div:nth-child(1) label').trigger('click');
     $('.tmbuyboxa #ProductSection-tmoz2 fieldset>div:nth-child(1) label').trigger('click');
     
        $('.tmbuyboxa .tmbpricee').text('$168.00');
      $('.tmbuyboxa .tmperbottlee').text('$2.00');
      $('.tmbuyboxa .tmnservingb').text('72 Servings (9 bottles)');
      });

      $(".tmbuyboxa .tmssd").click(function() {
      $('.tmbuyboxa .tmoneshot>div.tmmactive').removeClass('tmmactive');
      $(this).addClass('tmmactive');
      $('.tmbuyboxa #ProductSection-tmoz2 fieldset>div:nth-child(2) label').trigger('click');
      $('.tmbuyboxa #ProductSection-tmoz2 fieldset>div:nth-child(2) label').trigger('click');
     
        $('.tmbuyboxa .tmbpricee').text('$76.50');
      $('.tmbuyboxa .tmperbottlee').text('$3.18');
      $('.tmbuyboxa .tmnservingb').text('24 Servings (3 bottles)');
      });

// 2nd Buy Box

      $(".tmbuyboxb .tmn-variant>div:first-child").click(function() {
      $('.tmbuyboxb .tmn-variant>div.tmactive').removeClass('tmactive');
      $(this).addClass('tmactive');
      $('.tmbuyboxb .tmtwoshot').show();
      $('.tmbuyboxb .tmoneshot').hide();
      $('.tmbuyboxb #AddToCart-tmoz3').show();
      $('.tmbuyboxb #AddToCart-tmoz4').hide();
      $('.tmbuyboxb .tmbprice').text('$336.00');
      $('.tmbuyboxb .tmtwoshot>div.tmmactive').removeClass('tmmactive');
      $('.tmbuyboxb .tmssaa').addClass('tmmactive');
     $('.tmbuyboxb #ProductSelect-tmoz3-option-0>div:first-child label').trigger('click');
     $('.tmbuyboxb #ProductSelect-tmoz3-option-0>div:first-child label').trigger('click');
    
        $('.tmbuyboxb .tmperbottle').text('$2.00');
      $('.tmbuyboxb .tmnservinga').text('144 Servings (18 bottles)');
      });

      $(".tmbuyboxb .tmn-variant>div:nth-child(2)").click(function() {
      $('.tmbuyboxb .tmn-variant>div.tmactive').removeClass('tmactive');
      $(this).addClass('tmactive');
      $('.tmbuyboxb .tmtwoshot').hide();
      $('.tmbuyboxb .tmoneshot').show();
      $('.tmbuyboxb #AddToCart-tmoz3').hide();
      $('.tmbuyboxb #AddToCart-tmoz4').show();
      $('.tmbuyboxb .tmbpricee').text('$168.00');
      $('.tmbuyboxb #ProductSelect-tmoz4-option-0>div:nth-child(1) label').trigger('click');
      $('.tmbuyboxb #ProductSelect-tmoz4-option-0>div:nth-child(1) label').trigger('click');
     
        $('.tmbuyboxb .tmoneshot>div.tmmactive').removeClass('tmmactive');
      $('.tmbuyboxb .tmsscc').addClass('tmmactive');
      $('.tmbuyboxb .tmperbottlee').text('$2.00');
      $('.tmbuyboxb .tmnservingb').text('72 Servings (9 bottles)');
      });

     $(".tmbuyboxb .tmssaa").click(function() {
      $('.tmbuyboxb .tmtwoshot>div.tmmactive').removeClass('tmmactive');
      $(this).addClass('tmmactive');
      $('.tmbuyboxb #ProductSelect-tmoz3-option-0>div:first-child label').trigger('click');
      $('.tmbuyboxb #ProductSelect-tmoz3-option-0>div:first-child label').trigger('click');
     
       $('.tmbuyboxb .tmbprice').text('$336.00');
      $('.tmbuyboxb .tmperbottle').text('$2.00');
      $('.tmbuyboxb .tmnservinga').text('144 Servings (18 bottles)');
      });
    
      $(".tmbuyboxb .tmssbb").click(function() {
      $('.tmbuyboxb .tmtwoshot>div.tmmactive').removeClass('tmmactive');
      $(this).addClass('tmmactive');
      $('.tmbuyboxb #ProductSelect-tmoz3-option-0>div:nth-child(2) label').trigger('click');
      $('.tmbuyboxb #ProductSelect-tmoz3-option-0>div:nth-child(2) label').trigger('click');
    
        $('.tmbuyboxb .tmbprice').text('$136.00');
      $('.tmbuyboxb .tmperbottle').text('$2.83');
      $('.tmbuyboxb .tmnservinga').text('48 Servings (6 bottles)');
      });
    
      $(".tmbuyboxb .tmsscc").click(function() {
      $('.tmbuyboxb .tmoneshot>div.tmmactive').removeClass('tmmactive');
      $(this).addClass('tmmactive');
      $('.tmbuyboxb #ProductSelect-tmoz4-option-0>div:nth-child(1) label').trigger('click');
      $('.tmbuyboxb #ProductSelect-tmoz4-option-0>div:nth-child(1) label').trigger('click');
    
        $('.tmbuyboxb .tmbpricee').text('$168.00');
      $('.tmbuyboxb .tmperbottlee').text('$2.00');
      $('.tmbuyboxb .tmnservingb').text('72 Servings (9 bottles)');
      });

      $(".tmbuyboxb .tmssdd").click(function() {
      $('.tmbuyboxb .tmoneshot>div.tmmactive').removeClass('tmmactive');
      $(this).addClass('tmmactive');
      $('.tmbuyboxb #ProductSelect-tmoz4-option-0>div:nth-child(2) label').trigger('click');
      $('.tmbuyboxb #ProductSelect-tmoz4-option-0>div:nth-child(2) label').trigger('click');
     
        $('.tmbuyboxb .tmbpricee').text('$76.50');
      $('.tmbuyboxb .tmperbottlee').text('$3.18');
      $('.tmbuyboxb .tmnservingb').text('24 Servings (3 bottles)');
      });

    
  